export interface UserModelData {
  result: UserModel;
}

export class UserModel {
  id: number;
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  profilePictureId: string;
  tenant: TenantModel;
  passwordResetCode: string;
  permissions: string[];

  isImpersonated: boolean;
  impersonationDetails: ImpersonationDetailsModel;

  isTenantAdmin: boolean;

  setUser(user: any) {
    this.id = user.id;
    this.name = user.name || '';
    this.surname = user.surname || '';
    this.userName = user.userName || '';
    this.emailAddress = user.emailAddress || '';
    this.tenant = user.tenant || null;

    this.profilePictureId = user.profilePictureId;

    this.permissions = user.permissions || [];

    this.isImpersonated = user.isImpersonated;
    this.impersonationDetails = user.impersonationInformation || null;

    this.isTenantAdmin = user.isAdministrator || false;
    this.passwordResetCode=user.passwordResetCode || '';
  }
}

export class TenantModel {
  id: number;
  name: string;
  tenancyName: string;
}

export class ImpersonationDetailsModel {
  userId: number;
  tenantId: number;
}
